module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PN8WRL/tc-custom/9780300143010.jpg?1738496181967",
      "alt": "This image is the cover for the book Somme"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Somme\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v(">This analysis of the decision-making that led to the Somme offensive is “a major addition to the literature on the military history of the Great War.” (Jay Winter, author of "), _c('i', [_vm._v("The Great War in History")]), _vm._v(")"), _c('br'), _c('br'), _vm._v("Despite superior air and artillery power, British soldiers died in catastrophic numbers at the Battle of Somme in 1916. What went wrong, and who was responsible? This book meticulously reconstructs the battle, assigns responsibility to military and political leaders, and changes forever the way we understand this encounter and the history of the Western Front."), _c('br'), _c('br'), _vm._v("“A magisterial piece of scholarship. . . . It is a model of historical research and should do much to further our understanding of the Great War and how it was fought.” —Contemporary Review "), _c('br'), _c('br'), _vm._v("“Revisionist history at its best.” —Library Journal (starred review)"), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robin Prior, Trevor Wilson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Yale University Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0